import { SessionType } from "../Components/Session/Types";

export const SaveSessions = (sessions: SessionType[]) => {
  localStorage.setItem("sessions", JSON.stringify(sessions));
};

export const GetSessions = (): SessionType[] => {
  const jsonStr = localStorage.getItem("sessions");
  if (!jsonStr) {
    return [];
  }
  return JSON.parse(jsonStr) as SessionType[];
};

export const Reset = () => {
  localStorage.clear();
}
